import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDatepickerConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { GrievanceService } from 'src/app/shared/services/grievance.service';
import { IKeyValuePair } from 'src/app/_models/common/common';
import { IPaged } from 'src/app/_models/common/IPaged';

@Component({
  selector: 'app-grievance',
  templateUrl: './grievance.component.html',
  styleUrls: ['./grievance.component.css']
})
export class GrievanceComponent implements OnInit {

  private readonly PAGE_SIZE = 10;
  loading: boolean;
  userMasterId;
  fromMinDate;
  fromMaxDate;
  fromStartDate;
  toMinDate;
  toMaxDate;
  toStartDate;
  id;
  returTypes: any[];

  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'Id',
    sortDir: 'Desc',
    refNo: ',',
    createdFrom: ',',
    createdTo: ',',
    isActive: ',',
    status: ',',
    isReturn85ER1: '0',
    userMasterId: '',
    retururl: 0,
    id: 0,
  };

  columns = [

    { title: 'Ref No', key: 'id', isSortable: false },
    { title: 'Shala Id', key: 'id', isSortable: false },
    { title: 'Created On', key: 'createdOn', isSortable: false },
    { title: 'User Name', key: 'submitedYear', isSortable: false },
    { title: 'Query Type', key: 'fillingPeriod', isSortable: false },
    { title: 'Status', key: 'status', isSortable: false },
    {}
  ];
  ngOnInit(): void {
    this.bindDropDown();
  }

  pageURL;
  pageViewGriJSURL;
  pageViewGriEmpURL;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private commonService: CommonService,
    private grievanceService: GrievanceService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private authService: AuthService) {

    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort ? params.sort : 'Id';
        this.query.sortDir = params.sortDir ? params.sortDir : this.query.sortDir;
        this.query.refNo = params.refNo ? params.refNo : '';
        this.query.createdFrom = params.createdFrom ? params.createdFrom : '';
        this.query.createdTo = params.createdTo ? params.createdTo : '';
        this.query.isActive = params.isActive ? params.isActive : '';
        this.query.status = params.status ? params.status : '';
        this.query.id = params.id ? params.id : '0';
        this.PopulateSubmitReports();
        this.createCloseGrievanceForm();
        this.createRecellGrievanceForm();
      });
  }
  closeGrievanceForm: FormGroup;
  createCloseGrievanceForm() {
    this.closeGrievanceForm = this.fb.group({
      userMasterId: [''],
      statusId: [2],
      closeComment: ['', Validators.required]
    });
  }

  recellGrievanceForm: FormGroup;
  createRecellGrievanceForm() {
    this.recellGrievanceForm = this.fb.group({
      userMasterId: [''],
      statusId: [3],
      recellComment: ['', Validators.required]
    });
  }
  reason: any;
  reasonid: any;

  onRecell(submitreturnreason, reason, id) {
    this.reason = reason;
    this.reasonid = id;

    this.modalService.open(submitreturnreason, { size: 'lg', windowClass: 'fade' });
  }
  onClose(submitreturnreason, reason, id) {
    this.reason = reason;
    this.reasonid = id;

    this.modalService.open(submitreturnreason, { size: 'lg', windowClass: 'fade' });
  }
  onViewSubmission(id) {
    this.router.navigate(['/admin/grievance/view-grievance'], {
      queryParams: {
        id: id,
      }
    });
  }

  changeCreatedDateEvent(event: any) {
    if (this.query.createdFrom) {
      this.query.createdTo = '';
      const splitDate = this.query.createdFrom.split('-');;
      const daya = Number(splitDate[0]);
      const montha = Number(splitDate[1]);
      const yeara = Number(splitDate[2]);
      const currentDate = new Date();
      this.toMinDate = { year: yeara, month: montha, day: daya + 1 };
      this.toMaxDate = { year: currentDate.getFullYear() + 18, month: currentDate.getMonth() + 1, day: currentDate.getDate() }
      this.toStartDate = { year: yeara, month: montha, day: daya };
    }
  }
  private PopulateSubmitReports() {
    this.grievanceService.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      });
  }

  bindDropDown() {
    this.commonService.getGrievanceTypes().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.returTypes = response;
      }
    });
  }
  sortBy(columnName) {
    this.query.page = 1;
    if (this.query.sort === columnName) {
      this.query.sortDir = (this.query.sortDir == "Descending" ? "Ascending" : "Descending");
    } else {
      this.query.sort = columnName;
      this.query.sortDir = "Descending";
    }

    this.router.navigate(['/admin/regions/states/districts/schools'], {
      queryParams: this.query
    });
  }
  filter() {
    this.query.page = 1;
    this.router.navigate(['/admin/grievance'], {
      queryParams: this.query
    });
  }

  close() {
    this.modalService.dismissAll();
  }

  resetClick() {
    this.router.navigate(['/admin/grievance']);
    this.query.refNo = '';
    this.query.isActive = '';
    this.query.status = '';
    this.query.createdFrom = '';
    this.query.createdTo = '';
    this.query.isReturn85ER1 = '0';
  }

  userGrievance: any;
  submit() {
    if (this.closeGrievanceForm.valid) {
      this.loading = true;
      this.grievanceService.get(this.reasonid).subscribe((response: any) => {
        if (response) {
          this.userGrievance = response;
          this.userGrievance.statusId = this.reason;
          if (this.reason == 2) {
            this.userGrievance.closeComment = this.closeGrievanceForm.value.closeComment;
          } else {
            this.userGrievance.recallComment = this.closeGrievanceForm.value.closeComment;
          }
          if (this.reasonid) {
            this.grievanceService.update(this.reasonid, this.userGrievance).subscribe(() => {
              if (this.reason == 2) {
                this.toastrService.success('Grievance has been close successfully.');
              } else {
                this.toastrService.success('Grievance has been recall successfully.');
              }
              this.close();
              this.PopulateSubmitReports();
            },
              (error) => console.log('HTTP Error', error),
              () => this.loading = false);
          }
        }
      });
    }
  }
}

